import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'FilterNwamounts',
    pure: false
})
export class FilterNwamounts implements PipeTransform {
    transform(items: any[], type): any {
            let sumLiabilities = 0,
                sumAssets = 0;
            for (let i = 0; i < items.length; i++) {
                if (items[i].type === 'Liability') {
                    // tslint:disable-next-line:radix
                    sumLiabilities += parseInt(items[i].value);
                } else {
                    // tslint:disable-next-line:radix
                    sumAssets += parseInt(items[i].value);
                }
            }

            if (type === 'Assets') {
                return sumAssets.toLocaleString();
            } else if (type === 'Liabilities') {
                return sumLiabilities.toLocaleString();
            } else {
                return (sumAssets - sumLiabilities).toLocaleString();
            }
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/mmam/angular/src/app/filter.nwamounts.ts